export enum CommissionType {
  Starter = 'Starter',
  Growth = 'Growth',
  Elite = 'Elite',
  Custom = 'Custom',
  None = 'None'
}
export enum MDRValues {
  Starter = 2.9,
  Growth = 2.5,
  Elite = 2.5,
  Custom = 0
}
export enum CommissionRates {
  Starter = 16,
  Growth = 20,
  Elite = 24,
  Custom = 0
}
export enum CommissionOffer {
  Starter = 0,
  Growth = 0,
  Elite = 0,
  Custom = 0
}
export enum DurationOffer {
  Starter = '30 days',
  Growth = '60 days',
  Elite = '90 days',
  Custom = ''
}
export enum AddOffer {
  Starter = 'PHP 0 (PDF)',
  Growth = 'PHP 20,000 (PDF)',
  Elite = 'PHP 40,000 (PDF)',
  Custom = ''
}
export interface Commission {
  name: string;
  mdr: number;
  commissionRate: number;
  custom: string;
}
export interface PromoCommission {
  name: string;
  commissionOffer: number;
  duration: string;
  advertising: string;
}
